import { type LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StatCardProps {
  icon?: LucideIcon;
  value: string | number;
  label: string;
  trend?: {
    percent: number;
    positive: boolean;
  };
  borderColor?: string;
  className?: string;
}

export function StatCard({
  icon: Icon,
  value,
  label,
  trend,
  borderColor = 'border-l-brand-500',
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        'bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-col gap-3 border-l-4',
        borderColor,
        className,
      )}
      aria-label={`${label}: ${value}`}
    >
      <div className="flex items-start justify-between">
        {Icon && (
          <div
            className="flex items-center justify-center w-10 h-10 rounded-lg bg-brand-50 shrink-0"
            aria-hidden="true"
          >
            <Icon size={20} className="text-brand-500" />
          </div>
        )}
        {trend && (
          <span
            className={cn(
              'inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full tap-auto',
              trend.positive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700',
            )}
            aria-label={`${trend.positive ? 'Up' : 'Down'} ${Math.abs(trend.percent)}%`}
          >
            {trend.positive ? (
              <TrendingUp size={11} aria-hidden="true" />
            ) : (
              <TrendingDown size={11} aria-hidden="true" />
            )}
            {trend.positive ? '+' : ''}{trend.percent}%
          </span>
        )}
      </div>
      <div>
        <p className="text-2xl font-bold text-gray-900 leading-none">{value}</p>
        <p className="mt-1 text-sm text-gray-500">{label}</p>
      </div>
    </div>
  );
}
